var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarouselArrowRight = function SvgCarouselArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.11.377a.667.667 0 0 1 .988 0l4.447 4.753a.785.785 0 0 1 0 1.057l-4.448 4.753a.667.667 0 0 1-.988 0 .784.784 0 0 1 0-1.056l3.254-3.478H0V4.912h18.363L15.11 1.434a.783.783 0 0 1 0-1.057"
  })));
};
export default SvgCarouselArrowRight;